import { IAppState } from '../../redux';
import { ICheckoutDetail } from '../../redux/reducers';

export function selectCheckoutDetails(state: IAppState): Array<ICheckoutDetail> {
  return state.checkoutInfo.details;
}
